import axios, { AxiosInstance } from "axios";
import { getUserAccessToken } from "./selectors/Accounts";

let API_URL = window.location.origin.toString() + "/";
//let API_URL = "https://dabapistaging.azurewebsites.net/";
//let API_URL = "https://dabapidev.azurewebsites.net/";
// let API_URL = "https://dabdev.azurewebsites.net/";

let accessTokenPassed = getUserAccessToken();

export class Http {
	public static axios(): AxiosInstance {
	return axios.create({
		baseURL: API_URL,
		headers: {
			'Content-Type': 'application/json',
		}
	});
  }
}
